import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp, widthPercentageToDP as wp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  modal: {
    flex: 1,
    width: '100%',
    height: '100%',
    margin: 0,
  },
  container: {
    flex: 1,
    backgroundColor: '#000',
    opacity: 0.6,
    width: '100%',
    height: '100%',
  },
  modalBox: {
    width: wp('100%'),
    height: hp('100%'),
    flexDirection: 'column',
    alignSelf: 'flex-start',
  },
  modalContentLarge: {
    backgroundColor: '#fff',
    width: wp('30%'),
    height: hp('100%'),
    flexDirection: 'column',
    alignSelf: 'flex-start',
  },
  modalContentSmall: {
    backgroundColor: '#fff',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  closeIconContainer: {
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    marginLeft: 60,
  },
  modalTextLarge: {
    alignSelf: 'center',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: 20,
    lineHeight: 24,
  },
  modalTextSmall: {
    alignSelf: 'center',
    textAlign: 'left',
    fontWeight: '600',
    fontSize: 16,
    lineHeight: 24,
  },
  iconListLarge: {
    height: 35,
    width: 35,
    marginRight: 20,
  },
  iconListSmall: {
    height: 30,
    width: 30,
    marginRight: 20,
  },
  modalBtnContainer: {
    flex: 0.3,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
  },
  btnContainerStyle: {
    flex: 0.3,
  },
  confirmBtnStyle: {
    backgroundColor: '#0F6657',
    borderRadius: 12,
    height: '65%',
  },
  confirmBtnStyleSmall: {
    backgroundColor: '#0F6657',
    borderRadius: 12,
    height: '82%',
  },
  confirmBtnText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: '700',
  },
  cancelBtnStyle: {
    backgroundColor: '#fff',
    borderWidth: 2,
    borderColor: '#0F6657',
    borderRadius: 12,
    height: '65%',
  },
  cancelBtnStyleSmall: {
    backgroundColor: '#fff',
    borderWidth: 2,
    borderColor: '#0F6657',
    borderRadius: 12,
    height: '82%',
  },
  cancelBtnText: {
    color: '#0F6657',
    fontSize: 12,
    fontWeight: '700',
  },
  itemContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignContent: 'space-between',
    marginVertical: 15,
    marginHorizontal: 20,
  },
});
